import React, {useEffect, useState} from "react";
import {Fade, Stack} from "@mui/material";
import {editMenuItems} from "./editMenuItems";
import {getRoutes} from "../../../../utils/nodeMapper";
import {NodeEditPanel} from "./components/NodeEditPanel";
import {NodeTabContent} from "./components/NodeTabContent";
import {UI, rgba} from "../uiTokens";

export const EditNodeMenu = ({
                                 open,
                                 selectedNode,
                                 selectedRoute,
                                 nodes,
                                 onDuplicate,
                                 onClose,
                                 onUpdate,
                                 onRemove,
                                 project,
                                 flow,
                                 showHideMenuButton = true,
                             }) => {
    const [node, setNode] = useState(selectedNode);
    const [items, setItems] = useState([]);
    const [value, setValue] = useState("");

    useEffect(() => {
        if (selectedNode) {
            setItems(editMenuItems[selectedNode.type] || []);
            if (selectedNode?.id !== node?.id) {
                setValue("");
            }
        }
        setNode(selectedNode || null);
    }, [selectedNode]);

    useEffect(() => {
        if (selectedRoute) {
            const route = getRoutes(node?.routes)?.find(r => r?.id === selectedRoute);
            if (route) {
                setValue(route?.variant);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRoute, node?.id]);

    const onChangeData = (key, val) => {
        setNode(prev => {
            const state = {...prev};
            state.data[key] = val;
            return state;
        });
    };

    if (!open || !node) return null;

    return (
        <>
            {/* Left panel — fixed 310px width, absolute maxHeight so it never
                depends on an ancestor having an explicit height. */}
            <Stack direction="row" sx={{width: 310, height: "100%", maxHeight: "calc(100dvh - 48px)"}}>
                <NodeEditPanel
                    node={node}
                    setNode={setNode}
                    onUpdate={onUpdate}
                    onDuplicate={onDuplicate}
                    value={value}
                    setValue={setValue}
                    items={items}
                    onRemove={onRemove}
                    onClose={onClose}
                    showHideMenuButton={showHideMenuButton}
                    project={project}
                    flow={flow}
                />
            </Stack>

            {value && (
                <Fade in={!!value} timeout={500}>
                    {/* Right tab-content panel — own maxHeight + overflowY so it
                        scrolls internally instead of the whole page. */}
                    <Stack
                        direction="column"
                        gap={2}
                        sx={{
                            p: 1,
                            pb: 0,
                            minWidth: 280,
                            maxWidth: 320,
                            width: "100%",
                            height: "100%",
                            minHeight: 0,
                            overflowY: "auto",
                            borderRight: `1px solid ${value ? rgba(UI.accent, 0.14) : "transparent"}`,
                        }}
                    >
                        <NodeTabContent
                            value={value}
                            node={node}
                            setNode={setNode}
                            onUpdate={onUpdate}
                            onChangeData={onChangeData}
                            nodes={nodes}
                            project={project}
                            flow={flow}
                            selectedRoute={selectedRoute}
                        />
                    </Stack>
                </Fade>
            )}
        </>
    );
};
